/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { PlanResponse1 } from '../models';
/**
 * PlansApi - axios parameter creator
 * @export
 */
export const PlansApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve detailed information about a specific plan
         * @summary Get plan details by ID
         * @param {string} planId Plan ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanById: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('getPlanById', 'planId', planId)
            const localVarPath = `/api/v1/plans/{planId}`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of plans for a specific product code
         * @summary Get plans by product code
         * @param {string} [productCode] Product code to filter plans (e.g., EDUSENSE_PLATFORM)
         * @param {string} [page] Page number for pagination (0-based)
         * @param {string} [size] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlans: async (productCode?: string, page?: string, size?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productCode !== undefined) {
                localVarQueryParameter['productCode'] = productCode;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve plans for a specific product code using path parameter
         * @summary Get plans by product code (alternative endpoint)
         * @param {string} productCode Product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlansByProductCode: async (productCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCode' is not null or undefined
            assertParamExists('getPlansByProductCode', 'productCode', productCode)
            const localVarPath = `/api/v1/products/{productCode}/plans`
                .replace(`{${"productCode"}}`, encodeURIComponent(String(productCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlansApi - functional programming interface
 * @export
 */
export const PlansApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlansApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve detailed information about a specific plan
         * @summary Get plan details by ID
         * @param {string} planId Plan ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanById(planId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanResponse1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanById(planId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.getPlanById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a list of plans for a specific product code
         * @summary Get plans by product code
         * @param {string} [productCode] Product code to filter plans (e.g., EDUSENSE_PLATFORM)
         * @param {string} [page] Page number for pagination (0-based)
         * @param {string} [size] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlans(productCode?: string, page?: string, size?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanResponse1>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlans(productCode, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.getPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve plans for a specific product code using path parameter
         * @summary Get plans by product code (alternative endpoint)
         * @param {string} productCode Product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlansByProductCode(productCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanResponse1>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlansByProductCode(productCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.getPlansByProductCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlansApi - factory interface
 * @export
 */
export const PlansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlansApiFp(configuration)
    return {
        /**
         * Retrieve detailed information about a specific plan
         * @summary Get plan details by ID
         * @param {PlansApiGetPlanByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanById(requestParameters: PlansApiGetPlanByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlanResponse1> {
            return localVarFp.getPlanById(requestParameters.planId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of plans for a specific product code
         * @summary Get plans by product code
         * @param {PlansApiGetPlansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlans(requestParameters: PlansApiGetPlansRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlanResponse1>> {
            return localVarFp.getPlans(requestParameters.productCode, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve plans for a specific product code using path parameter
         * @summary Get plans by product code (alternative endpoint)
         * @param {PlansApiGetPlansByProductCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlansByProductCode(requestParameters: PlansApiGetPlansByProductCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlanResponse1>> {
            return localVarFp.getPlansByProductCode(requestParameters.productCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlansApi - interface
 * @export
 * @interface PlansApi
 */
export interface PlansApiInterface {
    /**
     * Retrieve detailed information about a specific plan
     * @summary Get plan details by ID
     * @param {PlansApiGetPlanByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApiInterface
     */
    getPlanById(requestParameters: PlansApiGetPlanByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlanResponse1>;

    /**
     * Retrieve a list of plans for a specific product code
     * @summary Get plans by product code
     * @param {PlansApiGetPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApiInterface
     */
    getPlans(requestParameters?: PlansApiGetPlansRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlanResponse1>>;

    /**
     * Retrieve plans for a specific product code using path parameter
     * @summary Get plans by product code (alternative endpoint)
     * @param {PlansApiGetPlansByProductCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApiInterface
     */
    getPlansByProductCode(requestParameters: PlansApiGetPlansByProductCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlanResponse1>>;

}

/**
 * Request parameters for getPlanById operation in PlansApi.
 * @export
 * @interface PlansApiGetPlanByIdRequest
 */
export interface PlansApiGetPlanByIdRequest {
    /**
     * Plan ID
     * @type {string}
     * @memberof PlansApiGetPlanById
     */
    readonly planId: string
}

/**
 * Request parameters for getPlans operation in PlansApi.
 * @export
 * @interface PlansApiGetPlansRequest
 */
export interface PlansApiGetPlansRequest {
    /**
     * Product code to filter plans (e.g., EDUSENSE_PLATFORM)
     * @type {string}
     * @memberof PlansApiGetPlans
     */
    readonly productCode?: string

    /**
     * Page number for pagination (0-based)
     * @type {string}
     * @memberof PlansApiGetPlans
     */
    readonly page?: string

    /**
     * Number of items per page
     * @type {string}
     * @memberof PlansApiGetPlans
     */
    readonly size?: string
}

/**
 * Request parameters for getPlansByProductCode operation in PlansApi.
 * @export
 * @interface PlansApiGetPlansByProductCodeRequest
 */
export interface PlansApiGetPlansByProductCodeRequest {
    /**
     * Product code
     * @type {string}
     * @memberof PlansApiGetPlansByProductCode
     */
    readonly productCode: string
}

/**
 * PlansApi - object-oriented interface
 * @export
 * @class PlansApi
 * @extends {BaseAPI}
 */
export class PlansApi extends BaseAPI implements PlansApiInterface {
    /**
     * Retrieve detailed information about a specific plan
     * @summary Get plan details by ID
     * @param {PlansApiGetPlanByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public getPlanById(requestParameters: PlansApiGetPlanByIdRequest, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).getPlanById(requestParameters.planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of plans for a specific product code
     * @summary Get plans by product code
     * @param {PlansApiGetPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public getPlans(requestParameters: PlansApiGetPlansRequest = {}, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).getPlans(requestParameters.productCode, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve plans for a specific product code using path parameter
     * @summary Get plans by product code (alternative endpoint)
     * @param {PlansApiGetPlansByProductCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public getPlansByProductCode(requestParameters: PlansApiGetPlansByProductCodeRequest, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).getPlansByProductCode(requestParameters.productCode, options).then((request) => request(this.axios, this.basePath));
    }
}

